import { Link } from "react-router-dom";
import { Phone, MessageCircle, FileText } from "lucide-react";
import { useSettings } from "@/context/SettingsContext";
import { telLink, waLink } from "@/lib/api";

export default function MobileActionBar() {
  const s = useSettings();
  return (
    <div
      className="fixed inset-x-0 bottom-0 z-50 grid grid-cols-3 border-t border-[#2c2c2e] bg-[#111111] md:hidden"
      data-testid="mobile-action-bar"
    >
      <a
        href={telLink(s)}
        data-testid="mobile-bar-call"
        className="flex h-14 flex-col items-center justify-center gap-0.5 text-[11px] font-semibold text-white"
      >
        <Phone size={18} aria-hidden="true" /> Call
      </a>
      <a
        href={waLink(s)}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="mobile-bar-whatsapp"
        className="flex h-14 flex-col items-center justify-center gap-0.5 bg-[#18864B] text-[11px] font-semibold text-white"
      >
        <MessageCircle size={18} aria-hidden="true" /> WhatsApp
      </a>
      <Link
        to="/quote"
        data-testid="mobile-bar-enquire"
        className="flex h-14 flex-col items-center justify-center gap-0.5 bg-[#F5B700] text-[11px] font-semibold text-[#111111]"
      >
        <FileText size={18} aria-hidden="true" /> Enquire
      </Link>
    </div>
  );
}
